import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesPapeisPermissoes {
  ler: boolean;
}

/** Espelho do RBAC real: `GET /api/v1/auth/permissoes` exige recurso `auth`, só concedido a `admin`. */
export function permissoesPapeisPermissoes(papel: PapelUsuario): PermissoesPapeisPermissoes {
  return { ler: papel === 'admin' };
}
